var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-file-list"},[(_vm.canUpload)?_c('upload-attach',{on:{"uploaded":_vm.uploadedFile}}):_vm._e(),_c('new-table',{ref:"tableRef",staticClass:"file-table",attrs:{"data":_vm.attachFiles,"columns":_vm.attachColumns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }